import { storyPoints, testimonials } from "@/mocks/content";

export default function Story() {
  return (
    <section id="story" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-store-2-fill"></i>
            关于本站
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            一个把火影玩坏的地方
          </h2>
          <p className="mt-3 text-sm text-foreground-700 md:text-base">
            火影黄本子由一群热爱火影又爱整活的乐子人创建，我们坚持原创恶搞与二创，
            把最真实的吐槽和最有趣的梗分享给每一位粉丝。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {storyPoints.map((p) => (
            <article
              key={p.title}
              className="rounded-lg border border-background-200/80 bg-background-100 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{p.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-12">
          <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">乐子人的口碑</h3>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6"
              >
                <div className="flex gap-1 text-secondary-500">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <i key={s} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 font-heading text-background-50">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-600">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}